import { MatchStatus } from '@uefadigital/panenka';
import clsx from 'clsx';

import { BestPlayersStats } from 'components/BestPlayersStats';
import { MatchStats } from 'components/MatchStats';
import useIsDesktop from 'hooks/useIsDesktop';
import { useMatchData } from 'hooks/useMatchData';

export const StatisticsTab = ({ isPDFPrint = false }) => {
  const { competitionId, seasonYear, matchData } = useMatchData();

  const isDesktop = useIsDesktop();

  const BestPlayerStatsComponent = (
    <BestPlayersStats
      matchData={matchData}
      isDesktop={isPDFPrint ? true : isDesktop}
      competitionId={competitionId}
      seasonYear={seasonYear}
      isPDFPrint={isPDFPrint}
    />
  );
  const MatchStatsComponent = (
    <MatchStats matchData={matchData} isDesktop={isPDFPrint ? true : isDesktop} isPDFPrint={isPDFPrint} />
  );

  return (
    <div className={clsx('pk-container', isPDFPrint && 'pr-page-break--before')}>
      {matchData.status === MatchStatus.FINISHED && (
        <div className="pk-col pk-col--span-12">{BestPlayerStatsComponent}</div>
      )}
      <div className="pk-col pk-col--span-12">{MatchStatsComponent}</div>
    </div>
  );
};
